module.exports = __webpack_public_path__ + "static/media/Third.c3872e17.png";